import { gql } from "@apollo/client";

export const MUTATION_REMOVE_LINKED_CARD = gql`
  mutation RemoveLinkedCard($id: ID!, $externalId: ID!) {
    removeLinkedCard(id: $id, externalId: $externalId) {
      id
    }
  }
`;
